import type { IconAsset } from '../Icon.types';

const code = (
  <path
    clipRule='evenodd'
    d='M5.62538 0.506001C2.56694 0.506001 0.514 2.98139 0.514 6.03838C0.514 9.5077 5.36062 13.6526 9.5128 16.4203C13.6664 13.6526 18.4566 9.44114 18.5131 6.03838C18.5637 2.98139 16.5845 0.506001 13.5261 0.506001C12.2211 0.506001 10.8973 1.1961 9.5128 2.5792C8.12826 1.1961 6.93035 0.506001 5.62538 0.506001V0.506001Z'
    fill='transparent'
    fillRule='evenodd'
    stroke='currentColor'
  />
);

export const heartOutline: IconAsset = {
  regular: {
    l: {
      code,
    },
    m: {
      code,
    },
    s: {
      code,
    },
  },
};
